import * as React from 'react';
import appService from '../../../Service';
import {showCustomDialog, showErrorDialog, showSuccessDialog,closeDialog,Input,
Form, showLoading , Util } from 'baziigram';
import {useSelector, useDispatch} from 'react-redux'
import {persist} from "../../../redux/actions"
import {useForm} from "react-hook-form";
import  "./styles.css";
import {connectToHub,disconnect} from '../../Group'
import {
    GROUP_ACTION_CLEAR,
    GROUP_ACTION_PERSIST
} from "../../../redux/GROUP/group.constant";
import {useEffect} from "react";
import  {STORAGE_KEY,dictionary} from "../../../constants";
import {GetUser , UpdateUser} from "../../../Util/user"

const CreateGroup = ({gameId,language}) => {


    const {formData  } = useSelector(state =>  state.group)
    const dispatch = useDispatch();
    const form = useForm({defaultValues:{...formData},shouldFocusError: true});
    const {reset} = form
    const updateState = (state) => {
        dispatch(persist(state, GROUP_ACTION_PERSIST))
    }

    useEffect(()=>{
        reset({...formData})
        },[])

    const onError=(error)=>{
        window.dispatchEvent(new CustomEvent("baziigram-invalid-input"));
    }

    const handleSubmit = async (data , error) => {
        showLoading(true)
        let key = await window.crypto.subtle.generateKey(
                                            {
                                              name: "AES-CBC",
                                              length: 256
                                            },
                                            true,
                                            ["encrypt", "decrypt"]
                                          );

         await Util.Crypto.wrapKey(key , formData.groupName+"-"+gameId , (wrapped)=>{
             let u = GetUser()
               u[formData.groupName+"-"+gameId] = wrapped
                 UpdateUser(u)
              })

        let user = GetUser()
        appService.CreateNewGroup(gameId ,formData.groupName , formData.logo , user[formData.groupName+"-"+gameId]).then(async res => {
        closeDialog("createGroupModal")
        showSuccessDialog(res.message,"")
         window.dispatchEvent(
                new CustomEvent("connectToHub", {
                    detail: { name:formData.groupName , flag:formData.logo , role:0  , connected:0,disconnected:0 },
                })
            );
           setTimeout(disconnect , 500)
           dispatch(persist(null, GROUP_ACTION_CLEAR))

        }).catch(err => {
            showErrorDialog(err.message || err)
        }).finally(async res => {

            showLoading(false)
        })
    }




    const changeValue = (id, value) => {
        formData[id] = value
        updateState({formData})
         if(id=="logo"){
        try{
        closeDialog()
         }catch(err){}
         }
    }




    const showGroupImages=()=>{
        let body = <div className="text-center d-flex flex-column py-3">
            <div className={"w-100"}><button
                type="button"
                className="close my-2 mr-4"
                data-dismiss="modal"
                aria-label="Close"
                onClick={()=>{
                closeDialog()
                setTimeout(showGroupDialog,800)}}
            >
                <span aria-hidden="true">&times;</span>
            </button></div>
            <div className="text-center  rtl ">
                <div className=" d-flex flex-row-justify-content-center">
                    <img onClick={()=>changeValue("logo",1)}  src="/images/Group/flags/1.png"
                         className="group-flag"/>
                        <img onClick={()=>changeValue("logo",2)} src="/images/Group/flags/2.png"
                             className="group-flag"/>
                            <img onClick={()=>changeValue("logo",3)}
                                 src="/images/Group/flags/3.png" className="group-flag"/>
                </div>
                <div className=" d-flex flex-row-justify-content-center">
                    <img onClick={()=>changeValue("logo",4)} src="/images/Group/flags/4.png"
                         className="group-flag"/>
                        <img onClick={()=>changeValue("logo",5)} src="/images/Group/flags/5.png"
                             className="group-flag"/>
                            <img onClick={()=>changeValue("logo",6)}
                                 src="/images/Group/flags/6.png" className="group-flag"/>
                </div>
                <div className=" d-flex flex-row-justify-content-center">
                    <img onClick={()=>changeValue("logo",7)} src="/images/Group/flags/7.png"
                         className="group-flag"/>
                        <img onClick={()=>changeValue("logo",8)} src="/images/Group/flags/8.png"
                             className="group-flag"/>
                            <img onClick={()=>changeValue("logo",9)}
                                 src="/images/Group/flags/9.png" className="group-flag"/>
                </div>

            </div>

            </div>

        showCustomDialog(body)
    }

const endClose=(e)=>{
  if(e.animationName=="hide-dialog")
    {document.getElementById("createGroupModal").classList.remove("hide-dialog");
    document.getElementById("createGroupModal-container").style.display="none"
    }

  }

    return ( <div className="dialog-container" id="createGroupModal-container">
    <div className="dialog-content" id="createGroupModal" onAnimationEnd={endClose}>
    <div className={"ltr d-flex flex-row justify-content-between  mx-3"}><button
                                   type="button"
                                   className="close my-2 mr-4"
                                   data-dismiss="modal"
                                   aria-label="Close"
                                   onClick={()=>{
                                   closeDialog("createGroupModal")
                                   updateState({formData:{groupName:"",logo:1}})
                                   reset();
                                   }}
                               >
                                   <span aria-hidden="true">&times;</span>
                               </button></div>
    <div  className={"mx-2 ltr d-flex flex-row justify-content-between align-items-center rtl"}>

                   <div style={{maxWidth:"350px"}} className="d-flex m-auto flex-column justify-content-center  h-100 flex-fill">

                          <Form formClassName="border-0" buttonTitle={dictionary.ok[language]} form={form}  onError={onError} onSubmit={handleSubmit} >

                                           <div className={"container mt-0 d-flex flex-column justify-content-center"}>
                                               <div className={"w-100 align-items-start justify-content-center "}>
                                                   <div className={"col-12  my-2"}>
                                                       <img onClick={showGroupImages}   style={{display:"block"}}  className={" group-flag"} src={`/images/Group/flags/${formData.logo}.png`}/>
                                                  <div className={"text-center text-dark"}>{dictionary.changeGroupFlag[language]}</div>
                                                   </div>
                                                   <div className={"col-12  my-2"}>
                                                       <Input
                                                           form={form}
                                                           label={dictionary.groupName[language]}
                                                           inputLabelClass="bg-light"
                                                           className="form-control"
                                                           maxLength={30}
                                                           type={"text"}
                                                           id={"groupName"}
                                                           required={true}
                                                           value={formData.groupName}
                                                           validator={(value)=>{ return value.length>0}}
                                                           onChange={(id, value) =>
                                                               changeValue(id, value)
                                                           }
                                                       />
                                                   </div>
                                                </div>
                                           </div>
                                       </Form>
                                   </div>
                                 </div></div>
                                 </div>

    );
};

export default CreateGroup;


export const showGroupDialog=()=>{
     document.getElementById("createGroupModal-container").style.display="block"
     setTimeout(function(){document.getElementById("createGroupModal").classList.add("show-dialog")},100)

}

